const state = {
  dados: {
    uf: '',
    uf_id: '',
    tipo_imovel_servico: '',
    tipo_imovel_servico_id: '',
    mes_id: '',
    mes_sigla: '',
    ano: '',
    glosa: '',
    multa: '',
    total: ''
  }
}

const mutations = {
  setConfirmarMultaGlosa (state, obj) {
    state.dados = obj
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/confirmarMultaGlosa.js